<script>
import baseMixin from '@/mixins/baseMixin'
import CommentModel from '@/models/comments/commentModel'
import DisputeHistoryOriginalBookingTimesCommentModel from '@/models/comments/disputeHistoryOriginalBookingTimesCommentModel'
import timesheetMixin from '@/mixins/timesheetMixin'
import { ResolveOperations } from '@/constants/disputes/ResolveOperations'
import { mapGetters } from 'vuex'
import { avatarColourSets } from '@/helpers/color-helpers'
import DateFormatToken from '@/constants/date/DateFormatToken'
import CommentBase from './comment-base.vue'
import CommentBaseText from './comment-base-text.vue'
import CommentDisputeHistoryActionBtn from './comment-dispute-history-action-btn.vue'

export default {
  name: 'CommentDisputeHistoryOriginal',
  components: { CommentBase, CommentBaseText, CommentDisputeHistoryActionBtn },
  mixins: [baseMixin, timesheetMixin],
  props: {
    comment: {
      type: CommentModel,
      required: true,
    },
  },
  data: () => {
    return { DateFormatToken }
  },
  computed: {
    ...mapGetters({
      resolveStatus: 'disputes/resolveStatus',
    }),
    originalBookingCommentModel() {
      return new DisputeHistoryOriginalBookingTimesCommentModel(
        JSON.parse(this.comment.commentText)
      )
    },
    isSelected() {
      return this.resolveStatus === ResolveOperations.ORIGINAL
    },
    compButtonText() {
      if (this.isSelected) return this.$t('general.selected')
      return this.$t('comment.disputeHistory.useThisBtnText')
    },
    compAvatarColor() {
      return avatarColourSets.ateam_purple
    },
  },
  methods: {
    updateResolveStatus() {
      this.$store.commit('disputes/SET_FLYOUT', {
        key: 'resolveStatus',
        value: ResolveOperations.ORIGINAL,
      })
    },
  },
}
</script>

<template>
  <CommentBase
    :added-by="comment.addedBy"
    :subtitle="comment.getDateCreatedTimestamp()"
    :active="isSelected"
    :avatar-color="compAvatarColor"
    :avatar-icon="'mdi-calendar'"
  >
    <CommentBaseText class="mb-1"
      >{{ $t('comment.disputeHistory.original.title') }}:</CommentBaseText
    >

    <CommentBaseText
      >{{
        renderLocalTime(
          originalBookingCommentModel.startTime,
          DateFormatToken.HHmmss
        )
      }}
      -
      {{
        renderLocalTime(
          originalBookingCommentModel.endTime,
          DateFormatToken.HHmmss
        )
      }}</CommentBaseText
    >

    <CommentBaseText v-if="originalBookingCommentModel.breakMinutes">
      {{
        $t('comment.disputeHistory.original.breakMins', [
          originalBookingCommentModel.breakMinutes,
        ])
      }}
    </CommentBaseText>

    <template v-slot:actions>
      <CommentDisputeHistoryActionBtn
        :selected="isSelected"
        :text="compButtonText"
        @click="updateResolveStatus"
      />
    </template>
  </CommentBase>
</template>
